import React from 'react';
import AllAttachments from '../AllAttachments';

export default function Attachments() {
  return <AllAttachments canDelete={true} canUpload={true}/>;
}